import { render } from "./product-shoppable-outfits.vue?vue&type=template&id=6465cc9a"
import script from "./product-shoppable-outfits.vue?vue&type=script&lang=js"
export * from "./product-shoppable-outfits.vue?vue&type=script&lang=js"

import "./product-shoppable-outfits.vue?vue&type=style&index=0&id=6465cc9a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__